module.exports = __webpack_public_path__ + "img/5.07.thmb.67a7bbac.jpg";